export enum ExporterTypeEnum {
  API_REST_JSON = 1,
  API_REST_XML = 2,
  DIRECT_ACCESS_TO_BASE = 3,
}
